/**
 * Settings Layout
 * Tabbed navigation for all settings sections
 */

import { Outlet } from "react-router-dom";
import { TabNav, type Tab } from "@/components/shared";

const settingsTabs: Tab[] = [
  {
    label: "Profile",
    href: "/settings/profile",
    icon: "👤",
  },
  {
    label: "Billing",
    href: "/settings/billing",
    icon: "💳",
  },
  {
    label: "Team",
    href: "/settings/team",
    icon: "👥",
  },
  {
    label: "API Keys",
    href: "/settings/api-keys",
    icon: "🔑",
  },
];

export function SettingsLayout() {
  return (
    <div className="min-h-screen bg-bg-primary">
      <div className="mx-auto max-w-7xl px-6 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-text-primary">Settings</h1>
          <p className="mt-2 text-sm text-text-secondary">
            Manage your account settings and preferences
          </p>
        </div>

        {/* Tab Navigation */}
        <TabNav tabs={settingsTabs} className="mb-8" />

        {/* Content */}
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
